export default {
    QQ_APP_ID: "101994947",
    QQ_REDIRECT_URI: "https://lsstop.com/qq/myback",
    WEIBO_APP_ID: "4277939909",
    WEIBO_REDIRECT_URI: "https://lsstop.com/weibo/myback",
    TENCENT_CAPTCHA: "2069698282"
}
